import { MapPin, Phone, Mail, ExternalLink } from 'lucide-react';

export default function JamaatOffice() {
  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <div className="text-white py-16" style={{ background: 'linear-gradient(to right, #001f3f, #001f3f)' }}>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl md:text-6xl font-bold mb-4">Jamaat Office</h1>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">

        {/* Intro */}
        <div className="mb-16">
          <div className="bg-white border-2 border-dawoodi-navy/10 rounded-xl p-10 hover:shadow-lg transition-all">
            <p className="font-poppins text-gray-700 leading-relaxed text-lg">
              Please contact Jamaat Office via email or phone for Jamaat Clearance, Aqiqah/Misaq/Nikah details,
              changes to payment schedules, Warqatul Tarqhees renewal, etc.
            </p>
          </div>
        </div>

        {/* Divider */}
        <div className="my-12 h-1 bg-gradient-to-r from-transparent via-dawoodi-gold/30 to-transparent rounded-full"></div>

        {/* Contact Details */}
        <div className="mb-16">
          <h2 className="font-playfair text-4xl font-bold text-dawoodi-navy mb-8">Contact Details</h2>
          <div className="bg-white border-2 border-dawoodi-navy/10 rounded-xl p-10 hover:shadow-lg transition-all">
            <div className="space-y-6">
              <div className="flex items-start space-x-4">
                <MapPin className="w-6 h-6 text-dawoodi-gold flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-playfair font-bold text-dawoodi-navy text-lg mb-1">Location</h3>
                  <p className="font-poppins text-gray-700">Outside 1st Floor Bairao Masjid</p>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Phone className="w-6 h-6 text-dawoodi-gold flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-playfair font-bold text-dawoodi-navy text-lg mb-1">Tel</h3>
                  <a
                    href="tel:7323904214"
                    className="font-poppins text-dawoodi-gold font-semibold hover:underline"
                  >
                    732-390-4214
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <Mail className="w-6 h-6 text-dawoodi-gold flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-playfair font-bold text-dawoodi-navy text-lg mb-1">Email</h3>
                  <a
                    href="mailto:JamaatOffice@njjamaat.org"
                    className="font-poppins text-dawoodi-gold font-semibold hover:underline"
                  >
                    JamaatOffice@njjamaat.org
                  </a>
                </div>
              </div>

              <div className="flex items-start space-x-4">
                <ExternalLink className="w-6 h-6 text-dawoodi-gold flex-shrink-0 mt-1" />
                <div>
                  <h3 className="font-playfair font-bold text-dawoodi-navy text-lg mb-1">Finance Portal</h3>
                  <a
                    href="https://finance.njjamaat.org"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="font-poppins text-dawoodi-gold font-semibold hover:underline"
                  >
                    finance.njjamaat.org
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  );
}
